import {Livraison} from '@/models';

export default [
	{
		path: '/livraisons',
		name: 'livraisons',
		meta: {
			title: 'Liste des essences achetées',
			granted: [ 'API_GET_LIVRAISON' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Livraison.vue')
	},
	{
		path: '/livraisons/edit/:id',
		name: 'livraison-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Livraison/Edit.vue'),
				class: Livraison
			}),
		},
		meta: {
			title: 'Edition d\'un livraison',
			granted: [ 'API_PUT_LIVRAISON' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
